import { getMainPage, redirectWindow, userlogoutWindow, DLZSAvailabilityWindow, logoutWindow, VerifyBeforeEnterProduct, BeforeEnterProduct, ShowVCodeCallBack } from '@/assets/js/fstsignu.js'
import { WeChatKeyLoginCheck } from './WeChatLogin';
import { loadFile } from '@/utils';
import router from '@/router';
import axios from 'axios';
import { ElMessageBox } from 'element-plus';
import md5 from 'md5';
import store from '@/store';

/**
 * 版本号(主.次.修订)
 * 主版本号：增加功能
 * 次版本号：修改导致不兼容
 * 修订版本号：修复错误
 * 修改JS时需更新版本号
 **/
const FstServiceVersion = "1.1.0";

//var firstPage = getMainPage(); //登录后的首页
var ukey = "F.K.SEC.S_ID"; //key固定不变
var ukeyExpired = ukey + ".Expried";
var vcodekey = "F.V.L.VCID"; //key固定不变

export let ProductId, apiAddress, transferUrl, targetUrl, cssfilehref, isOpenWeChatLogin, OProductId; //产品Id,登录api地址,中转地址,目标地址,是否启用微信登录

export var AutoLoginState = false;//自动登录状态，主要识别是否从其他产品已登录或者微信扫码登录，仅作用于登录页
export var isOpenVerifyCode = 0;

var receiveData = JSON.parse(loadFile('fstsign_.json'))
if (receiveData.casLogin) {
    ProductId = receiveData.casLogin.ProductId; //产品ID
    OProductId = ProductId;//原配置产品ID
    apiAddress = receiveData.casLogin.apiAddress; //post方法地址
    transferUrl = receiveData.weChatRedirectUrl.transferUrl;//中转地址，为了解决一个备案域名给多个产品使用
    targetUrl = receiveData.weChatRedirectUrl.targetUrl;//目标地址，设置login.html的地址
    isOpenWeChatLogin = receiveData.weChatRedirectUrl.isOpenWeChatLogin;
    cssfilehref = receiveData.weChatRedirectUrl.cssfilehref;
}
else {
    ProductId = "";
    apiAddress = "";
    transferUrl = "";
    targetUrl = "";
    ElMessageBox.alert('登录参数设置不完整！', '提示信息', {
        confirmButtonText: '确定',
        type: 'error',
        callback: action => {}
    })
}
export var Route_pdata = "api/dpdata/DPost", Route_qcpt = "api/dqcpt/DQPost";
var apiPathP = ConcatApiUrl(apiAddress, Route_pdata); //post方法地址
var apiPathQcpt = ConcatApiUrl(apiAddress, Route_qcpt); //平台基础信息地址

/**
 * 从url中取出指定name的参数
 * @param {string} name 参数名 
 * @param {string} win 窗口对象
 */
export function QueryString_F(name, win) {
    if (!win) {
        win = window;
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var search=win.location.hash.split("?")[1];
    if(!search){
        return null;
    }
    var n = search.match(reg);
    if (n != null) {
        return unescape(n[2]);
    }
    return null;
}


/**
 * 返回网站的根地址，如果应用程序名或虚拟目录名是以qcpt或fst开头，则返回的路径包含应用程序名或虚拟目录名。返回的地址结尾不含/
 */
function getUrlRootPath_F() {
    var rePath = "";//返回的路径;
    var allPath = window.location.href.replace(window.location.protocol + "//" + window.location.host + "/", ""); //这一句正常情况下和window.location.pathname取出的结果是一样的,但因为 window.location.pathname 在有的地方取出来时 路径第一个带了/所以 没有直接用它取 king2015-5-25
    allPath = trim_F(allPath);
    if (allPath.length > 1) //上面替换成功之后 要么是 "" (路径为 http://xx.xx.xx/) 要么为一个页面的地址 xx.aspx (http://xx.xx.xx/xx.aspx) 或 xx/xx.aspx,xx/ (http://xx.xx.xx/xx/xx.aspx,   http://xx.xx.xx/xx/)
    {
        var ipt = allPath.split('/')[0];//用来作判断的
        if (ipt.toLowerCase() == "qcpt" || ipt.substring(0, 3).toLowerCase() == "fst") //前三位是fst
        {
            rePath = "/" + ipt;
        }
    }
    return (window.location.protocol + "//" + window.location.host + rePath);
}

/**
 * 去掉字符串左右两边的空格后返回
 * @param {string} str 原字符串
 */
function trim_F(str) {
    return str.replace(/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g, '');
}

/**
 * 拼接API地址
 * @param {any} baseUrl 根地址，允许basePath的末尾是否携带 "/",例如：http://192.168.32.8/qcpt 或 http://192.168.32.8/qcpt/ 等
 * @param {any} routePath API路由地址，允许参数以"/"开头，如：api/Value/5 或 /api/value/5
 */
function ConcatApiUrl(baseUrl, routePath) {
    var url = "";
    url += baseUrl[baseUrl.length - 1] == "/" ? baseUrl.substr(0, baseUrl.length - 1) : baseUrl;
    url += ((routePath[0] == "/" ? "" : "/") + routePath);
    return url;
}

//服务插件版本校验
$(function () {
    !function () {
        /**
         * 版本号比较
         * @param {any} v1 版本1
         * @param {any} v2 版本2
         * @returns -1:v1小于v2; 1:v1大于v2; 0:v1==v2
         */
        function compareVersion(v1, v2) {
            var arr1 = v1.split("."),
                arr2 = v2.split(".");

            var temp1, temp2;
            //去除末尾0
            while ((temp1 = parseInt(arr1[arr1.length - 1])) === 0 || (temp2 = parseInt(arr2[arr2.length - 1])) === 0) {
                if (temp1 === 0) arr1.pop();
                if (temp2 === 0) arr2.pop();
            }
            var len = Math.max(arr1.length, arr2.length);
            for (var i = 0; i < len; i++) {
                var num1 = parseInt(arr1[i]),
                    num2 = parseInt(arr2[i]);
                if (isNaN(num1)) {
                    return -1;
                }
                if (isNaN(num2)) {
                    return 1;
                }
                if (num1 > num2) {
                    return 1;
                } else if (num1 < num2) {
                    return -1
                }
            }
            return 0;
        }

        var VaildVersion = async function () {
            var oRet = await execServiceApiSync(Route_pdata, "POST", JSON.stringify({ lx: "0" }))
            if (!!oRet && oRet.retCode == "0") {
                var apitemp = oRet.data.indexOf(".", oRet.data.indexOf(".") + 1),
                    jstemp = FstServiceVersion.indexOf(".", FstServiceVersion.indexOf(".") + 1),
                    apiVersions = oRet.data.substring(0, apitemp > -1 ? apitemp : oRet.data.length),
                    jsVersions = FstServiceVersion.substring(0, jstemp > -1 ? jstemp : FstServiceVersion.length);
                var re = compareVersion(jsVersions, apiVersions);
                if (re == 1) {
                    //JS的主次版本超过API接口的主次版本时提示
                    // zgt_window.zgt_winAlert("插件版本(" + FstServiceVersion + ")高于服务版本(" + oRet.data + ")，请升级服务程序", { icon: 5, title: '提示信息' });
                    ElMessageBox.alert("插件版本(" + FstServiceVersion + ")高于服务版本(" + oRet.data + ")，请升级服务程序", '提示信息', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: action => {}
                    })
                } else if (re == -1) {
                    //JS的主次版本低于API接口的主次版本时提示
                    // zgt_window.zgt_winAlert("插件版本(" + FstServiceVersion + ")低于服务版本(" + oRet.data + ")，请升级插件或程序", { icon: 5, title: '提示信息' });
                    ElMessageBox.alert("插件版本(" + FstServiceVersion + ")低于服务版本(" + oRet.data + ")，请升级插件或程序", '提示信息', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: action => {}
                    })
                }
            } else {
                ElMessageBox.alert("插件版本(" + FstServiceVersion + ")与服务版本（无）不匹配，可能程序配置有误或者服务程序版本较低导致，请检查程序配置或升级服务程序", '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {}
                })
            }
        };
        VaildVersion();
    }()
})

/**
 * 登录方法，成功跳转至首页,同时返回true；失败显示错误信息并返回false
 * @param {string} userZh 账号 
 * @param {string} password 密码
 */
export async function loginButtonPublic(userZh, password, vcvalue) {
    const userRole = store.state.role
    let firstPage = getMainPage(userRole)
    return await user_Login(userZh, password, firstPage, null, vcvalue)
}

/**
 * 获得用户登录信息，返回JSON对象，包含retCode,user,Msg。retCode为0时表示读取成功，retCode不为0时，错误信息在Msg。user包含UserInformation.UserLoginInfo序列化的字符串
 */
export async function getUserInfo() {
    var oJson = await GetUserInfoAPI();
    if (oJson.retCode == "909") {
        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
    }
    return oJson;
}

/**
 * 取用户信息接口
 * @param {any} [pid] 产品ID，可选参数，默认为配置文件产品ID
 */
function GetUserInfoAPI(pid) {
    pid = pid || ProductId;
    var userData = readData(); //登录证书
    if (userData == null) {
        var oJson1 = { retCode: "909", Msg: "用户信息过期!" };
        return oJson1;
    } else {
        //调用API获取用户信息
        var PSJ = JSON.stringify({ lx: "4", dlzs: userData, pid: pid });
        var oJson = execServiceApiSync(Route_pdata, "POST", PSJ);
        return oJson;
    }
}

/**
 * 获取平台用户登录信息，仅管理端页面(Jsddyjm.aspx或Jsddyjm.html)使用，产品的管理端入口都从平台进入
 * 返回JSON对象，包含retCode,user,Msg。retCode为0时表示读取成功，retCode不为0时，错误信息在Msg。user包含UserInformation.UserLoginInfo序列化的字符串
 * */
function GetPTUserInfo() {
    return GetUserInfoAPI("9999");
}

/**
 * 更新用户信息。将返回的JSON对象传给回调函数，对象包含retCode,Msg。retCode为0更新成功；1DLZS失效；2用户在其他地方登录；3客户端不存在DLZS；4添加产品证书失败；5DLZS续期失败；6登录证书与用户对象不匹配
 * @param {JSON} oUser 登录用户信息的json对象，基本信息基于UserInformation.UserLoginInfo
 * @param {string} cFunc 回调函数名 
 */
function setUserInfo(oUser, cFunc) {
    var userData = readData(); //登录证书
    if (userData == null) {
        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
        var oJson = { retCode: "909", Msg: "用户信息过期!" }
        cFunc(oJson);
    }
    else {
        //调用API获取用户信息
        var userStr = JSON.stringify(oUser);
        var PSJ = JSON.stringify({ lx: "5", dlzs: userData, user: userStr, pid: ProductId });
        execServiceApiAsync(Route_pdata, "POST", PSJ, cFunc);
    }
}

/**
 * 登录用户修改姓名，将返回的JSON对象传给回调函数，对象包含retCode,Msg。retCode为0修改成功
 * @param {string} userId_ 用户账号 
 * @param {string} userName_ 用户姓名
 * @param {string} cFunc 回调函数名
 */
function changeName(userId_, userName_, cFunc) {
    var userData = readData(); //登录证书
    if (userData == null) {
        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
        var oJson1 = { retCode: "909", Msg: "用户信息过期!" }
        cFunc(oJson1);
    }
    else {
        var PSJ = JSON.stringify({ lx: "17", dlzs: userData, userId: userId_, userName: userName_ });
        var oJson = execServiceApiSync(Route_pdata, "POST", PSJ);
        if (oJson.retCode == "0") {
            //更新成功后，再更新用户登录信息
            var oUser = getUserInfo();
            var jUser = JSON.parse(oUser.user);
            jUser.name = userName_;
            setUserInfo(jUser, cFunc);
        }
        else {
            cFunc(oJson);
        }
    }
}

/**
 * 登录用户修改姓名、密码，将返回的JSON对象传给回调函数，对象包含retCode,Msg。retCode为0修改成功
 * @param {string} userId_ 用户账号 
 * @param {string} userName_ 用户姓名
 * @param {string} userPwdOld_ 旧密码
 * @param {string} userPwd_ 新密码
 * @param {string} cFunc 回调函数名
 */
function changeNameAndPwd(userId_, userName_, userPwdOld_, userPwd_, cFunc) {
    var userData = readData(); //登录证书
    if (userData == null) {
        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
        var oJson1 = { retCode: "909", Msg: "用户信息过期!" }
        cFunc(oJson1);
    }
    else {
        var PSJ = JSON.stringify({ lx: "17", dlzs: userData, userId: userId_, userName: userName_, userPwdOld: userPwdOld_, userPwd: userPwd_ });
        var oJson = execServiceApiSync(Route_pdata, "POST", PSJ);
        if (oJson.retCode == "0") {
            //更新成功后，再更新用户登录信息
            var oUser = getUserInfo();
            var jUser = JSON.parse(oUser.user);
            jUser.name = userName_;
            setUserInfo(jUser, cFunc);
        }
        else {
            cFunc(oJson);
        }
    }
}

/**
 * 登录用户修改密码，将返回的JSON对象传给回调函数，对象包含retCode,Msg。retCode为0修改成功
 * @param {string} userId_ 用户账号 
 * @param {string} userPwdOld_ 旧密码
 * @param {string} userPwd_ 新密码
 * @param {string} cFunc 回调函数
 */
function changePwd(userId_, userPwdOld_, userPwd_, cFunc) {
    var userData = readData(); //登录证书
    if (userData == null) {
        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
        var oJson1 = { retCode: "909", Msg: "用户信息过期!" }
        cFunc(oJson1);
    }
    else {
        var PSJ = JSON.stringify({ lx: "17", dlzs: userData, userId: userId_, userPwdOld: userPwdOld_, userPwd: userPwd_ });
        var oJson = execServiceApiSync(Route_pdata, "POST", PSJ);
        cFunc(oJson);
    }
}

var timingHandle; //定时句柄

/**
 * 写登录证书
 * @param {string} nMinute 过期时间，单位分钟 
 * @param {string} userData 登录证书
 */
export function writeData(nMinute, userData) {
    var dd = new Date();
    var nSecond = nMinute * 60 * 1000;
    dd.setTime(dd.getTime() + nSecond);
    $.cookie(ukey, userData, { path: '/', expires: dd });
    $.cookie(ukeyExpired, dd, { path: '/', expires: dd });
}

/**
 * 读登录证书。返回登录证书
 */
export function readData() {
    return $.cookie(ukey);
}

/**
 * 删除登录证书。
 */
export function delData() {
    $.cookie(ukey, null, { path: '/' });
    $.cookie(ukeyExpired, null, { path: '/' });
}

/**
 * 同步执行API方法。返回执行结果为json对象或字符串
 * @param {string} apiUrl api地址 
 * @param {string} apiType 提交方式(POST，GET)
 * @param {string} apiData api提交数据
 */
async function execApiSync(apiUrl, apiType, apiData) {
    const res = await axios({
        url: apiUrl,
        method: apiType,
        data: typeof apiData == 'string' ? JSON.parse(apiData) : apiData,
        header: {
            'Content-Type': 'application/json',
        }
    })
    return res.data
}

/**
 * 异步执行API方法，执行结果json对象返回给回调函数
 * @param {string} apiUrl api地址 
 * @param {string} apiType 提交方式(POST，GET)
 * @param {string} apiData api提交数据
 * @param {string} aFunc 回调函数
 */
function execApiAsync(apiUrl, apiType, apiData, aFunc) {
    axios({
        url: apiUrl,
        method: apiType,
        data: typeof apiData == 'string' ? JSON.parse(apiData) : apiData,
        header: {
            'Content-Type': 'application/json',
        }
    }).then(res => {
        aFunc(res.data)
    }).catch(error => {
        console.log(error)
    })
}
/**
 * 同步执行单点登录API方法。返回执行结果为json对象或字符串
 * @param {any} routePath 单点登录API路由地址
 * @param {string} apiType 提交方式(POST，GET)
 * @param {string} apiData api提交数据
 */
export function execServiceApiSync(routePath, apiType, apiData) {
    var url = ConcatApiUrl(apiAddress, routePath),
        pars = JSON.stringify({ pars: Base64.encodeURI(apiData) });
    return execApiSync(url, apiType, pars)
}
/**
 * 异步执行单点登录API方法，执行结果json对象返回给回调函数
 * @param {any} routePath 单点登录API路由地址
 * @param {string} apiType 提交方式(POST，GET)
 * @param {string} apiData api提交数据
 * @param {string} aFunc 回调函数
 */
function execServiceApiAsync(routePath, apiType, apiData, aFunc) {
    var url = ConcatApiUrl(apiAddress, routePath),
        pars = JSON.stringify({ pars: Base64.encodeURI(apiData) });
    execApiAsync(url, apiType, pars, aFunc);
}

/**
 * MD5加密。返回MD5加密串
 * @param {string} str 待加密字符串 
 */
function stringToMD5(str) {
    return md5(str).toUpperCase();
}

/**
 * 用户从登录页登录，只被loginButton调用。成功返回true,失败返回false
 * @param {string} userZH 用户账号 
 * @param {string} password 密码
 * @param {string} cUrl 登录后跳转地址
 * @param {any} logoutPage 登录页面（重登录时或登录失效时跳转的页面）
 * @param {string} vcvalue 验证码
 */
async function user_Login(userZH, password, cUrl, logoutPage, vcvalue) {
    var loginState = false;
    var passwordMD5 = stringToMD5(password);
    const userRole = store.state.role;
    var obj = { lx: "1", uzh: userZH, pwd: passwordMD5, pid: ProductId, role: userRole, opid: OProductId };
    if (isOpenVerifyCode) {
        obj.vcid = $.cookie(vcodekey);
        obj.vcvalue = vcvalue;
    }
    var PSJ = JSON.stringify(obj);
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ); //返回登录证书，证书的格式与合法性在API里定义
    // 0登录成功；1添加登录证书失败；2添加产品证书失败，3存在用户登录证书,通知用户“登录未注销，是否注销重登录”
    if (oRet.retCode == "0") {
        loginState = true;
        writeData(parseInt(oRet.nMinute), oRet.userData);
        //redirectWindow(cUrl);
        CPZSCheck(cUrl, logoutPage);
    }
    else {
        if (oRet.retCode == "-1" || oRet.retCode == "1" || oRet.retCode == "2") {
            ElMessageBox.alert(oRet.Msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {}
            })
        }
        else {
            if (oRet.retCode == "3") {
                ElMessageBox.confirm(
                    '登录未注销，请注销再登录。',
                    '询问信息',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      'close-on-click-modal': false
                    }
                  )
                  .then(() => {
                        user_ReLogin(userZH, passwordMD5, cUrl, logoutPage, oRet.VCode ? oRet.VCode.RightCode : ""); //注销重新登录
                  })
            } else {
                oRet.Msg = oRet.Msg || '未指定错误。';
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {}
                })
            }
        }
        ShowVCode(oRet, ShowVCodeCallBack);
    }
        
    return loginState;
}

/**
 * 注销用户再重登录，只被user_Login调用
 * @param {string} userZH 用户账号 
 * @param {string} passwordMD5 MD5密码
 * @param {string} cUrl 登录后跳转地址
 * @param {any} [logoutPage] 登录页面（重登录时或登录失效时跳转的页面）
 * @param {string} vcvalue 验证码
 */
async function user_ReLogin(userZH, passwordMD5, cUrl, logoutPage, vcvalue) {
    const userRole = store.state.role
    //调用API重登录，API实现账号密码验证，删除登录证书，添加登录产品证书
    var obj = { lx: "8", uzh: userZH, pwd: passwordMD5, pid: ProductId, role: userRole, opid: OProductId };
    if (isOpenVerifyCode) {
        obj.vcid = $.cookie(vcodekey);
        obj.vcvalue = vcvalue;
    }
    var PSJ = JSON.stringify(obj);
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
    // 0重登录成功；1添加登录证书失败；2添加产品证书失败，3删除登录证书失败
    if (oRet.retCode == "0") {
        writeData(parseInt(oRet.nMinute), oRet.userData);
        //redirectWindow(cUrl);
        CPZSCheck(cUrl, logoutPage);
    }
    else {
        if (oRet.retCode == "1") {
            // zgt_window.zgt_winAlert('添加登录证书失败。', { icon: 5, title: '提示信息' });
            ElMessageBox.alert('添加登录证书失败。', '提示信息', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {}
            })
        }
        else if (oRet.retCode == "2") {
            //zgt_window.zgt_winAlert('添加产品证书失败。', { icon: 5, title: '提示信息' });
            ElMessageBox.alert('添加产品证书失败。', '提示信息', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {}
            })
        }
        else if (oRet.retCode == "3") {
            //zgt_window.zgt_winAlert('删除登录证书失败。', { icon: 5, title: '提示信息' });
            ElMessageBox.alert('删除登录证书失败。', '提示信息', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {}
            })
        }
        else {
            oRet.Msg = oRet.Msg || '未指定错误。';
            //zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' });
            ElMessageBox.alert(oRet.Msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {}
            })
        }
        ShowVCode(oRet, ShowVCodeCallBack);
    }
}

/**
 * 续期认证
 */
function user_Renew(cUrl) {
    var userData = readData(); //登录证书
    if (userData == null) {
        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
        // zgt_window.zgt_winAlert('用户信息过期。', { icon: 5, title: '提示信息' }, function () {
        //     DLZSAvailabilityWindow(cUrl);
        // });
        ElMessageBox.alert('用户信息过期。', '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: () => {
                DLZSAvailabilityWindow(cUrl)
            }
        })
    }
    else {
        //调用API续期
        var PSJ = JSON.stringify({ lx: "2", dlzs: userData, pid: ProductId });
        var user_RenewCallBack = function (oRet) {
            // 0续期成功；1DLZS失效；2用户在其他地方登录；【3客户端无DLZS】；4续期DLZS失败；5续期CPZS失败
            if (oRet.retCode == "0") {
                writeData(parseInt(oRet.nMinute), oRet.userData);
            }
            else {
                timingHandle = ClearTimingInterval(timingHandle); //清除定时器
                if (!!oRet.Msg) {
                    if (oRet.retCode != "5") {
                        // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                        //     delData();
                        //     DLZSAvailabilityWindow(cUrl);
                        // });
                        ElMessageBox.alert(oRet.Msg, '提示信息', {
                            confirmButtonText: '确定',
                            type: 'error',
                            callback: () => {
                                delData()
                                DLZSAvailabilityWindow(cUrl)
                            }
                        })
                    } else {
                        // zgt_window.zgt_winAlert("续期CPZS失败，请重新打开产品", { icon: 5, title: '提示信息' }, function () {
                        //     //CPZS证书续期失败时不删登录证书，考虑到平台可能还登录
                        //     DLZSAvailabilityWindow();
                        // });
                        ElMessageBox.alert('续期CPZS失败，请重新打开产品', '提示信息', {
                            confirmButtonText: '确定',
                            type: 'error',
                            callback: () => {
                                //CPZS证书续期失败时不删登录证书，考虑到平台可能还登录
                                DLZSAvailabilityWindow()
                            }
                        })
                    }
                }
                else {
                    // zgt_window.zgt_winAlert('未指定错误。', { icon: 5, title: '提示信息' }, function () {
                    //     DLZSAvailabilityWindow(cUrl);
                    // });
                    ElMessageBox.alert('未指定错误。', '提示信息', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: () => {
                            DLZSAvailabilityWindow(cUrl)
                        }
                    })
                }
            }
        }
        execServiceApiAsync(Route_pdata, "POST", PSJ, user_RenewCallBack);
    }
}

/**
 * 续期认证回调
 * @param {string} oRet">续期认证返回的JSON对象
 */
//function user_RenewCallBack(oRet) {
//    // 0续期成功；1DLZS失效；2用户在其他地方登录；【3客户端无DLZS】；4续期DLZS失败；5续期CPZS失败
//    if (oRet.retCode == "0") {
//        writeData(parseInt(oRet.nMinute), oRet.userData);
//    }
//    else {
//        timingHandle = ClearTimingInterval(timingHandle); //清除定时器
//        if (oRet.retCode == "1" || oRet.retCode == "2" || oRet.retCode == "3" || oRet.retCode == "4" || oRet.retCode == "5") {
//            zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' });
//        }
//        else {
//            zgt_window.zgt_winAlert('未指定错误。', { icon: 5, title: '提示信息' });
//        }
//    }
//}

/**
 * 退出跳转
 * @param {any} cUrl 跳转页面
 * @param {any} type 类型（1.退出产品 2.注销登录 3.登录证书无效）
 */
function toLogoutWindow(cUrl, type) {
    cUrl = (cUrl == "" || cUrl == null || cUrl == undefined || cUrl == "about:blank") ? "about:blank" : cUrl;
    type = type || 1;
    switch (type) {
        case 1: logoutWindow(cUrl); break;
        case 2: userlogoutWindow(cUrl); break;
        case 3: DLZSAvailabilityWindow(cUrl); break;
        default: logoutWindow(cUrl);
    }
}

/**
 * 地址跳转
 * @param {any} [cUrl] 页面URL（排除应用程序路径），cUrl为空或者为空白页或者未传，若能关闭窗口则关闭，不能则跳转至空白页
 */
export function RedirectUrl(cUrl) {
    if (cUrl == "" || cUrl == null || cUrl == undefined || cUrl == "about:blank") //返回空白页时，不需要网站路径，关闭网页
    {
        try {
            if (navigator.userAgent.indexOf("MSIE") > 0) {
                if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
                    window.opener = null;
                    window.close();
                } else {
                    window.open('', '_top');
                    window.top.close();
                }
            } else {
                window.opener = null;
                window.open('', '_self');
                window.close();
            }
        } catch (ex) { }
        window.location.href = "about:blank";//若无法关闭则跳转至空白页
    } else {
        //路由相同的情况下刷新页面
        if (router.currentRoute.value.path === cUrl){
            window.location.reload()
        } else {    //不同的情况下进行跳转
            // 如果能查到sessionStorage中存在gobg且有值，则跳转至进行特殊跳转
            if (sessionStorage.getItem('gobg') && sessionStorage.getItem('gobg') != undefined) {
               window.top.location.href=cUrl;
               sessionStorage.removeItem('gobg')
            } else {
                router.push(cUrl)            
            }

        }
    }
}

/**
 * 注销CPZS，关闭产品时使用
 * @param {string} [cUrl] 注销CPZS后跳转的地址,cUrl传入空值，跳转至空白页 
 */
export async function ProductLogout(cUrl) {
    var userData = readData();


    if (userData != null) {
        //调用API注销CPZS
        var PSJ = JSON.stringify({ lx: "6", dlzs: userData, pid: ProductId });
        var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
        // 0成功；1CPZS删除失败；3客户端不存在DLZS
        if (oRet.retCode != "0") {
            if (oRet.retCode == "1" || oRet.retCode == "3") {
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                //     toLogoutWindow(cUrl, 1);
                // });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: () => {
                        toLogoutWindow(cUrl, 1)
                    }
                })
            }
            else {
                oRet.Msg = oRet.Msg || '未指定错误。';
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                //     toLogoutWindow(cUrl, 1);
                // });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: () => {
                        toLogoutWindow(cUrl, 1)
                    }
                })
            }
        } else {
            toLogoutWindow(cUrl, 1);
        }
    }
    else {
        toLogoutWindow(cUrl, 1);
    }

}

/**
 * 注销DLZS
 * @param {string} cUrl 注销CPZS后跳转的地址,cUrl传入空值，跳转至空白页 
 */
export async function UserLogout(cUrl) {
    var userData = readData();
    timingHandle = ClearTimingInterval(timingHandle); //清除续租定时器
    if (userData != null) {
        var PSJ = JSON.stringify({ lx: "7", dlzs: userData });
        var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
        // 0成功；1DLZS删除失败；3客户端不存在DLZS
        if (oRet.retCode != "0") {
            if (oRet.retCode == "1" || oRet.retCode == "3" || oRet.retCode == "4") {
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                //     delData();
                //     toLogoutWindow(cUrl, 2);
                // });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: () => {
                        delData()
                        toLogoutWindow(cUrl, 2)
                    }
                })
            }
            else {
                oRet.Msg = oRet.Msg || '未指定错误。';
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                //     delData();
                //     toLogoutWindow(cUrl, 2);
                // });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: () => {
                        delData()
                        toLogoutWindow(cUrl, 2)
                    }
                })
            }
        } else {
            delData();
            toLogoutWindow(cUrl, 2);
        }

    } else {
        toLogoutWindow(cUrl, 2);
    }

}

/**
 * 查询登录状态。有效返回true,无效返回false
 */
function DLZSCheck() {
    var userData = readData(); //登录证书
    if (userData == null) {
        // zgt_window.zgt_winAlert('用户信息过期。', { icon: 5, title: '提示信息' });
        ElMessageBox.alert('用户信息过期。', '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {}
        })
        return false;
    }
    else {
        //调用API续期
        var PSJ = JSON.stringify({ lx: "12", dlzs: userData });
        var oRet = execServiceApiSync(Route_pdata, "POST", PSJ);
        //0有效，1DLZS失效，2在另一地方登录，3客户端不存在DLZS
        if (oRet.retCode != "0") {
            if (oRet.retCode == "1" || oRet.retCode == "2" || oRet.retCode == "3") {
                //zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {}
                })
            }
            else {
                oRet.Msg = oRet.Msg || '未指定错误。';
                //zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {}
                })
            }
            return false;
        }
        else {
            return true;
        }
    }
}

/**
 * 查询登录状态。有效时生成产品证书并自动续租，无效跳转至登录页。在登录后的首页调用
 * @param {string} cUrl 登录无效时的跳转地址
 */
export async function DLZSAvailability(cUrl) {
    var userData = readData(); //登录证书
    if (userData == null) {
        // zgt_window.zgt_winAlert('用户信息过期。', { icon: 5, title: '提示信息' }, function () {
        //     DLZSAvailabilityWindow(cUrl);
        // });
        ElMessageBox.alert('用户信息过期。', '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: () => {
                DLZSAvailabilityWindow(cUrl)
            }
        })
    }
    else {
        //调用API续期
        var PSJ = JSON.stringify({ lx: "12", dlzs: userData });
        var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
        //0有效，1DLZS失效，2在另一地方登录，3客户端不存在DLZS
        if (oRet.retCode != "0") {
            if (oRet.retCode == "1" || oRet.retCode == "2" || oRet.retCode == "3") {
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                //     delData();
                //     DLZSAvailabilityWindow(cUrl);
                // });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: () => {
                        delData();
                        DLZSAvailabilityWindow(cUrl);
                    }
                })
            }
            else {
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' }, function () {
                //     delData();
                //     DLZSAvailabilityWindow(cUrl);
                // });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: () => {
                        delData();
                        DLZSAvailabilityWindow(cUrl);
                    }
                })
            }

        }
        else {
            var fn = function (reftime) {
                var now = new Date();
                var expired = new Date($.cookie(ukeyExpired));
                var diffMin = getDateDiff(now, expired);
                if (diffMin < 7) {
                    user_Renew(cUrl)
                }
                var timingMsSecond = parseInt(reftime) * 1000;
                timingHandle = setInterval(function () { user_Renew(cUrl) }, timingMsSecond);
            }
            if (ProductId == "9999") //如果是平台
            {
                PSJ = JSON.stringify({ lx: "11", dlzs: userData, pid: ProductId });
                var oRet1 = await execServiceApiSync(Route_pdata, "POST", PSJ);
                //0添加产品证书成功，1添加产品证书失败，2登录证书续期失败，3账号信息错误，登录证书错误
                if (oRet1.retCode != "0") {
                    if (!!oRet1.Msg) {
                        // zgt_window.zgt_winAlert(oRet1.Msg, { icon: 5, title: '提示信息' }, function () {
                        //     if (!(oRet1.retCode == "5" || oRet1.retCode == "6")) {
                        //         delData();
                        //     }
                        //     DLZSAvailabilityWindow(cUrl);
                        // });
                        ElMessageBox.alert(oRet1.Msg, '提示信息', {
                            confirmButtonText: '确定',
                            type: 'error',
                            callback: () => {
                                if (!(oRet1.retCode == "5" || oRet1.retCode == "6")) {
                                    delData();
                                }
                                DLZSAvailabilityWindow(cUrl)
                            }
                        })
                    }
                    else {
                        // zgt_window.zgt_winAlert('未指定错误。', { icon: 5, title: '提示信息' }, function () {
                        //     DLZSAvailabilityWindow(cUrl);
                        // });
                        ElMessageBox.alert('未指定错误。', '提示信息', {
                            confirmButtonText: '确定',
                            type: 'error',
                            callback: () => {
                                DLZSAvailabilityWindow(cUrl)
                            }
                        })
                    }
                }
                else {
                    fn(oRet1.RefTime);
                }
            }
            else { //查产品证书是否有效
                PSJ = JSON.stringify({ lx: "3", dlzs: userData, pid: ProductId });
                var oRet1 = await execServiceApiSync(Route_pdata, "POST", PSJ);
                //0有效，1DLZS失效，2在另一地方登录，3客户端不存在DLZS，4CPZS无效
                if (oRet1.retCode != "0") {
                    if (!!oRet1.Msg) {
                        if (oRet1.retCode != "4") {
                            // zgt_window.zgt_winAlert(oRet1.Msg, { icon: 5, title: '提示信息' }, function () {
                            //     delData();
                            //     DLZSAvailabilityWindow(cUrl);
                            // });
                            ElMessageBox.alert(oRet1.Msg, '提示信息', {
                                confirmButtonText: '确定',
                                type: 'error',
                                callback: () => {
                                    delData()
                                    DLZSAvailabilityWindow(cUrl)
                                }
                            })
                        } else {
                            // zgt_window.zgt_winConfirm("产品证书失效，无法打开！要完成此操作，请点击确定按钮后打开产品重新登录。是否继续？", { icon: 5, title: '提示信息' }, function (isOk) {
                            //     if (isOk) {
                            //         delData();
                            //         DLZSAvailabilityWindow();
                            //     }
                            // });
                            ElMessageBox.confirm(
                                '产品证书失效，无法打开！要完成此操作，请点击确定按钮后打开产品重新登录。是否继续？',
                                '提示信息',
                                {
                                  confirmButtonText: '确定',
                                  cancelButtonText: '取消',
                                  type: 'error',
                                  'close-on-click-modal': false
                                }
                              )
                              .then(() => {
                                  delData()
                                  DLZSAvailabilityWindow()
                              })
                        }
                    }
                    else {
                        // zgt_window.zgt_winAlert('未指定错误。', { icon: 5, title: '提示信息' }, function () {
                        //     DLZSAvailabilityWindow(cUrl);
                        // });
                        ElMessageBox.alert('未指定错误。', '提示信息', {
                            confirmButtonText: '确定',
                            type: 'error',
                            callback: () => {
                                DLZSAvailabilityWindow(cUrl)
                            }
                        })
                    }
                }
                else {
                    fn(oRet1.RefTime);
                }
            }
        }
    }
}

/**
 * 计算时间差
 * @param {Date} startTime 起始时间
 * @param {Date} endTime 结束时间
 * @param {String} diffType 时间差类型，默认minute，可选值 millisecond|second|minute|hour|day
 */
function getDateDiff(startTime, endTime, diffType) {
    diffType = diffType || "minute";
    diffType = diffType.toLowerCase();
    var dic = {
        "millisecond": 1,
        "second": 1000,
        "minute": 1000 * 60,
        "hour": 1000 * 3600,
        "day": 1000 * 3600 * 24
    }
    if (!(diffType in dic)) {
        throw "diffType参数，为可选值，值需为 millisecond|second|minute|hour|day 其中之一。"
    }
    var timeType = dic[diffType] || 1;
    var diffTime = parseInt((endTime.getTime() - startTime.getTime()) / timeType);
    return diffTime
}

/**
 * 写Session,过期时间为12小时。结果Json对象返回给回调函数，retCode为0表示成功，1失败
 * @param {string} sessionKey Session键 
 * @param {string} sessionValue Session值
 * @param {string} writeSessionCallBack 回调函数
 */
function fWriteSession(sessionKey, sessionValue, writeSessionCallBack) {
    var userData = readData(); //登录证书
    var PSJ = JSON.stringify({ lx: "90", dlzs: userData, pid: ProductId, cKey: sessionKey, uData: sessionValue });
    execServiceApiAsync(Route_pdata, "POST", PSJ, writeSessionCallBack);
}

/**
 * 写Session。结果Json对象返回给回调函数，retCode为0表示成功，1失败
 * @param {string} sessionKey Session键 
 * @param {string} sessionValue Session值
 * @param {string} expired Session过期时间，单位分钟
 * @param {string} writeSessionCallBack 回调函数
 */
function fWriteSessionExpired(sessionKey, sessionValue, expired, writeSessionCallBack) {

    var userData = readData(); //登录证书
    var PSJ = JSON.stringify({ lx: "90", dlzs: userData, expire: expired, pid: ProductId, cKey: sessionKey, uData: sessionValue });
    execServiceApiAsync(Route_pdata, "POST", PSJ, writeSessionCallBack);
}

/**
 * 读Session。返回JSON对象，包含retCode(0成功，1失败),UserData(Session值，字符串)
 * @param {string} sessionKey">Session键
 */
function fReadSession(sessionKey) {
    var userData = readData(); //登录证书
    var PSJ = JSON.stringify({ lx: "91", dlzs: userData, pid: ProductId, cKey: sessionKey });
    var oRet = execServiceApiSync(Route_pdata, "POST", PSJ);
    return oRet;
}

/**
 *  删Session，结果返回回调函数。结果Json对象返回给回调函数，retCode为0表示成功，1失败
 * @param {string} sessionKey Session键 
 * @param {string} delSessionCallBack 回调函数
 */
function fDelSession(sessionKey, delSessionCallBack) {
    var userData = readData(); //登录证书
    var PSJ = JSON.stringify({ lx: "92", dlzs: userData, pid: ProductId, cKey: sessionKey });
    execServiceApiAsync(Route_pdata, "POST", PSJ, delSessionCallBack);
}

/**
 * 生成二维码，并显示在QRcodeDivID指定的div上
 * @param {string} QRcodeDivID 显示二维码的div的id
 * @param {string} applicationid 在腾讯注册的appid
 * @param {string} redirect_url 扫码授权后的回调地址,不能带端口号，如果中间有一个跳转页，可将最终页放在URL参数里
 * @param {string} cssfilehref 提供样式文件覆盖默认样式，空字符串表示不提供 
 * @param {string} backCallCode 用于保持请求和回调的状态，授权请求后原样带回给第三方，可验证数据真伪，防止CSRF攻击 
 */
function genQRcode(QRcodeDivID, applicationid, redirect_url, cssfilehref, backCallCode) {
    new WxLogin({
        id: QRcodeDivID,
        appid: applicationid,
        scope: "snsapi_login",
        redirect_uri: encodeURI(redirect_url),
        state: backCallCode,
        style: "black",//二维码黑白风格        
        href: cssfilehref
    });
}

/**
 * 微信二维码显示
 * @param {string} wxdiv 是页面上用于显示二维码的DIV的id
 * @param {string} bindUrl 微信绑定时的回调地址,微信扫码登录时不传此参数
 */
export async function showQRcode(wxdiv, bindUrl) {
    var redirect_url, reback;
    //如果有中转地址，微信重定向到中转地址；如果没有中转地址，重定向到目的地址
    if (transferUrl == null || transferUrl == "") { //没有中转地址
        redirect_url = ((bindUrl == null || bindUrl == "") ? targetUrl : bindUrl); //目的地址
    }
    else {
        redirect_url = transferUrl;//中转地址
        reback = ((bindUrl == null || bindUrl == "") ? Base64.encodeURI(targetUrl) : Base64.encodeURI(bindUrl)); //目的地址
    }
    var backCallCode = Math.ceil(Math.random() * 1000);
    if (reback) {
        backCallCode = backCallCode + "rebackurl" + reback;//将需要重定位的地址进行编码后放入状态里，在中转页解码出来进行跳转。
    }
    var dd = new Date();
    dd.setTime(dd.getTime() + 120000);
    $.cookie("weChatExpired", backCallCode, { path: '/', expires: dd });//验证回来的状态码
    $.cookie("wxdivcookie", wxdiv, { path: '/', expires: dd });//记录显示二维码的DVI的id
    var PSJ = JSON.stringify({ lx: "99990000" });
    var owx = await execServiceApiSync(Route_pdata, "POST", PSJ);//获取appid
    if (owx.retCode == "0") {
        genQRcode(wxdiv, owx.data, redirect_url, cssfilehref, backCallCode);
    }
}
/**
 * 登录前检查是否有登录证书，仅在登录页进入时使用。
 * 有则验证证书，有效时自动登录，无效则提示。
 * 无登录证书时则转为验证是否微信已扫码登录
 * @param {String} cUrl 登录后跳转地址
 * @param {any} logoutPage 登录页面（重登录时或登录失效时跳转的页面）
 * */
export async function DLZSCheckAutoLogin(cUrl, logoutPage) {
    var loginState = false;
    var userData = readData();
    const userRole = store.state.role
    var firstPage = getMainPage(userRole)
    cUrl = cUrl || firstPage;
    if (userData != null) {
        //调用API续期(检查登录证书)
        var PSJ = JSON.stringify({ lx: "12", dlzs: userData });
        var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
        //0有效，1DLZS失效，2在另一地方登录，3客户端不存在DLZS
        if (oRet.retCode == "0") {
            //自动登录
            AutoLoginState = true;
            loginState = true;
            // writeData(parseInt(oRet.nMinute), oRet.userData);
            CPZSCheck(cUrl, logoutPage);
        }
        else {
            if (oRet.retCode == "2") {
                ElMessageBox.confirm(
                    '登录未注销，请注销再重新登录。',
                    '提示信息',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'error',
                      'close-on-click-modal': false
                    }
                  )
                  .then(() => {
                    UserLogout(logoutPage)
                  })
            }
            else {
                oRet.Msg = oRet.Msg || '未指定错误。';
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {}
                })
            }
        }
    } else {
        if (isOpenWeChatLogin) {
            if (typeof WeChatKeyLoginCheck == "function" && !!WeChatKeyLoginCheck) {
                const role = store.state.role
                WeChatKeyLoginCheck(cUrl, logoutPage, role);
            }
        }
    }
    return loginState;
}

/**
 * 检查产品证书
 * @param {String} cUrl 登录后跳转地址
 * @param {any} logoutPage 登录页面（重登录时或登录失效时跳转的页面）
 */
export async function CPZSCheck(cUrl, logoutPage) {
    var userData = readData();
    var PSJ = JSON.stringify({ lx: "3", dlzs: userData, pid: ProductId });
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
    //0产品证书通过，1DLZS失效，2用户在其他地方登录，3客户端无DLZS，4CPZS无效
    if (oRet.retCode != "0") {
        if (oRet.retCode == "4") {
            //登录后要执行的内容
            redirectWindow(cUrl);
        } else if (oRet.retCode == "2") {
            ElMessageBox.confirm(
                '登录未注销，请注销再重新登录。',
                '提示信息',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'error',
                  'close-on-click-modal': false
                }
              )
              .then(() => {
                UserLogout(logoutPage)
              })
        } else {
            oRet.Msg = oRet.Msg || '未指定错误。';
            ElMessageBox.alert(oRet.Msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {}
            })
        }
    }
    else {
        //直接进入系统
        EnterProduct(cUrl);
    }
}

/**
 * 通过登录证书获取用户ID、角色（无产品证书时可取）
 * */
export function GetUserInfoWithNoCPZS() {
    var userData = readData();
    if (userData == null) {
        var oJson1 = { retCode: "909", Msg: "用户信息过期!" };
        return oJson1;
    } else {
        var PSJ = JSON.stringify({ lx: "19", dlzs: userData });
        var oJson = execServiceApiSync(Route_pdata, "POST", PSJ);
        return oJson;
    }
}

/**
 * 添加产品证书
 * @param {String} [classNo] 班级号
 * @param {String} [className] 班级名称
 * @returns {Boolean} true为添加成功，false失败同时提示原因
 */
async function CPZSAdd(classNo, className) {
    var isOk = false;
    var userData = readData();
    var PSJ = JSON.stringify({ lx: "11", dlzs: userData, pid: ProductId, ClassNO: classNo, ClassName: className });
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
    //0添加产品证书成功，1添加产品证书失败，2登录证书续期失败
    if (oRet.retCode == "0") {
        isOk = true;
    } else {
        ElMessageBox.alert(oRet.Msg, '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {}
        })
    }
    return isOk;
}

/**
 * 清除定时器
 * @param {number} [timingHandle]
 * @returns {null} 返回null值供定时器变量更新ID值
 */
function ClearTimingInterval(timingHandle) {
    clearInterval(timingHandle);
    return null;
}

/**
 * 进入系统
 * @param {String} cUrl 跳转页面Url
 * @param {String} [teachingNO] 学生教学班号
 * @param {String} [className] 学生教学班名次
 */
export async function EnterProduct(cUrl, teachingNO, className) {
    if (typeof VerifyBeforeEnterProduct == "function" && !!VerifyBeforeEnterProduct && !VerifyBeforeEnterProduct(teachingNO, className)) {
        return false;
    }
    //添加产品证书，设置选中班级(仅学生需选班级)
    if (await CPZSAdd(teachingNO, className)) {
        if (typeof BeforeEnterProduct == "function" && !!BeforeEnterProduct) {
            cUrl = await BeforeEnterProduct(cUrl);
        }
        RedirectUrl(cUrl);
    }
}

/**
 * 停止页面加载
 * @param {Boolean} IsForcedStop 是否强制停止，默认False，强制停止会以抛异常的形式停止运行后续的JS
 * */
function StopLoad(IsForcedStop) {
    IsForcedStop = IsForcedStop === true ? IsForcedStop : false;
    //停止AJAX请求
    var xmlhttp;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.abort();
    if (window.stop) {
        window.stop();
    } else {
        document.execCommand("Stop");
    }
    if (IsForcedStop) {
        //强制停止，防止后面继续运行JS
        throw Error("停止加载");
    }
}

/**
 * 课程数据管理页面加载时验证（Jsddyjm.aspx或Jsddyjm.html）
 * */
function VerifiedJsddyjmToPageLoad() {
    var oRet = GetPTUserInfo();
    if (oRet.retCode == "0") {
        var user = JSON.parse(oRet.user);
        if (user.role == 2) {
            var msg = "用户角色权限不够！";
            document.head.innerHTML = "";
            document.body.innerHTML = msg;
            StopLoad(true);
            return false;
        }
    } else {
        document.head.innerHTML = "";
        document.body.innerHTML = oRet.Msg;
        StopLoad(true);
        return false;
    }
    return true;
}

/**
 * 验证码初始化
 * @param {Function} callback 回调，用于处理显示或隐藏验证码时登录界面的样式
 * */
export async function InitVCode(callback) {
    await GetVCodeConfig();
    await GetVCode();
    if (typeof (callback) == "function") {
        if (isOpenVerifyCode) {
            callback(isOpenVerifyCode);
        }
    }
}

/**
 * 获取验证码配置
 * */
export async function GetVCodeConfig() {
    var PSJ = JSON.stringify({ lx: "860", pid: OProductId });
    var oRet = await execServiceApiSync(Route_pdata, "POST", PSJ);
    if (oRet.retCode == "0") {
        isOpenVerifyCode = oRet.data.OpenVCode;
    } else {
        // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' });
        ElMessageBox.alert(oRet.Msg, '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {}
        })
    }
}


/**
 * 获取验证码
 */
export async function GetVCode() {
    if (isOpenVerifyCode) {
        var vcid = $.cookie(vcodekey);
        var PSJ = JSON.stringify({ lx: "870", vcid: vcid, pid: OProductId });
        var fn = function (oRet) {
            if (oRet.retCode == "0") {
                ShowVCode(oRet, ShowVCodeCallBack);
            } else {
                // zgt_window.zgt_winAlert(oRet.Msg, { icon: 5, title: '提示信息' });
                ElMessageBox.alert(oRet.Msg, '提示信息', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: action => {}
                })
            }
        }
        await execServiceApiAsync(Route_pdata, "POST", PSJ, fn);
    }
}

/**
 * 显示验证码
 * @param {object} 验证码结果 {VCodeExpire:2(有效时长分钟),VCode:{VCID:"验证码ID",Image:"Base64图片"}}
 * @param {Function} callback 显示验证码回调
 */
export function ShowVCode(oRet, callback) {
    if (oRet.VCode) {
        var dd = new Date();
        var nMinute = oRet.VCodeExpire;
        var nSecond = nMinute * 60 * 1000;
        dd.setTime(dd.getTime() + nSecond);
        $.cookie(vcodekey, oRet.VCode.VCID, { path: '/', expires: dd });
        if (typeof (callback) == "function") {
            callback(oRet);
        }
    }
}

// 修改登录状态
export function changeAutoLoginState(){
    AutoLoginState = true
}
